import React, { Fragment, useEffect, useRef, useState } from 'react';
import Checkbox from 'b2b-ui-components-lib/lib/components/checkbox';
import './bulkAction.scss';
import { DeleteSites } from './Delete-sites';
import { ContractPeriod } from './Contract-period';
import { PreOrderPeriod } from './PreOrderPeriod';
import { ChangeServiceType } from './Change-service-type';
import { isNLD_OR_LL, isPreOrder } from 'common/constants/app.constants';
import { getTotalLinks } from './formControl.service';

type Props = {
  updateRecords: Function;
  records: any;
  reFetchRecords: Function;
  onConfigSiteWithExcel: Function;
};

export const BulkActions = ({ updateRecords, records, reFetchRecords, onConfigSiteWithExcel }: Props) => {
  const [showDelteSites, setShowDeleteSites] = useState(false);
  const [showChangeService, setShowChangeService] = useState(false);
  const [showContractPeriod, setShowContractPeriod] = useState(false);
  const [showPreOrderPeriod, setShowPreOrderPeriod] = useState(false);

  const [selectedSites, setSelectedSites] = useState([]);

  const onSelectAllHandler = (isChecked: boolean) => {
    updateRecords?.((oldData: any) => {
      const rows: Array<any> = oldData?.content;
      const updatedRows = rows.map((row) => ({ ...row, checkBox: { ...row?.checkBox, isChecked } }));
      return { ...oldData, content: updatedRows };
    });
  };

  const isAllChecked = () => {
    return records.content.reduce((flag: boolean, { checkBox: { isChecked } = { isChecked: false } }: any) => {
      return flag && isChecked;
    }, true);
  };

  const isAnyChecked = () => {
    let value = false;
    records.content.forEach(({ checkBox: { isChecked } = { isChecked: false } }: any) => {
      if (isChecked) {
        value = isChecked;
      }
    });

    return value;
  };

  const deleteClickHanlders = () => {
    setShowDeleteSites(true);
  };

  const contractPeriodHandler = () => {
    setShowContractPeriod(true);
  };

  const preOrderPeriodHandler = () => {
    setShowPreOrderPeriod(true);
  };

  const serviceTypeHandler = () => {
    setShowChangeService(true);
  };

  useEffect(() => {
    const checkedSites = records?.content?.filter(({ checkBox: { isChecked = false } = {} }: any) => {
      return isChecked;
    });

    setSelectedSites(checkedSites);
  }, [records]);

  if (Array.isArray(records?.content) && records.content?.length === 0) {
    return null;
  }

  return (
    <>
      <div className="select_sites_filter">
        <ul className="bulk_action_list">
          <li>
            <Checkbox checked={isAllChecked()} onChange={onSelectAllHandler}>
              <div className="text">
                {' '}
                Select All {selectedSites?.length > 0 ? `(${getTotalLinks(selectedSites)} ${getTotalLinks(selectedSites) > 1 ? 'Links' : 'Link'} Selected)` : ''}
              </div>
            </Checkbox>
          </li>
          {isAnyChecked() && (
            <>
              {isPreOrder() ? (
                <li>
                  <span className="action_text" onClick={preOrderPeriodHandler}>
                    Change Pre Order Period
                  </span>
                </li>
              ) : (
                <li>
                  <span className="action_text" onClick={contractPeriodHandler}>
                    Change Contract Period
                  </span>
                </li>
              )}
              {!isNLD_OR_LL() && (
                <li>
                  <span className="action_text" onClick={serviceTypeHandler}>
                    Change Service Type
                  </span>
                </li>
              )}

              <li>
                <span className="action_text" onClick={deleteClickHanlders}>
                  Delete Links
                </span>
              </li>
            </>
          )}
        </ul>

        {showDelteSites && <DeleteSites hidePopup={() => setShowDeleteSites(false)} records={selectedSites} reFetchRecords={reFetchRecords}></DeleteSites>}
        {showContractPeriod && <ContractPeriod hidePopup={() => setShowContractPeriod(false)} records={selectedSites} reFetchRecords={reFetchRecords} />}
        {showPreOrderPeriod && <PreOrderPeriod hidePopup={() => setShowPreOrderPeriod(false)} records={selectedSites} reFetchRecords={reFetchRecords} />}
        {showChangeService && (
          <ChangeServiceType hidePopup={() => setShowChangeService(false)} records={selectedSites} reFetchRecords={reFetchRecords} onConfigSiteWithExcel={onConfigSiteWithExcel} />
        )}
      </div>
    </>
  );
};
